import { render, staticRenderFns } from "./Substitutions.vue?vue&type=template&id=5c87fc69"
import script from "./Substitutions.vue?vue&type=script&lang=js"
export * from "./Substitutions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports